/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiArtifactFromJSON, StreemApiArtifactToJSON, } from './';
export function StreemApiListStreemshotsResponseFromJSON(json) {
    return StreemApiListStreemshotsResponseFromJSONTyped(json, false);
}
export function StreemApiListStreemshotsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'streemshotArtifacts': !exists(json, 'streemshot_artifacts') ? undefined : (json['streemshot_artifacts'].map(StreemApiArtifactFromJSON)),
        'nextPageToken': !exists(json, 'next_page_token') ? undefined : json['next_page_token'],
        'totalSize': !exists(json, 'total_size') ? undefined : json['total_size'],
    };
}
export function StreemApiListStreemshotsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'streemshot_artifacts': value.streemshotArtifacts === undefined ? undefined : (value.streemshotArtifacts.map(StreemApiArtifactToJSON)),
        'next_page_token': value.nextPageToken,
        'total_size': value.totalSize,
    };
}
//# sourceMappingURL=StreemApiListStreemshotsResponse.js.map